// extracted by mini-css-extract-plugin
module.exports = {"dataItem":"DataItem_dataItem__3Ivpb"};